var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPoliciesWidgetEmptyStateIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2929 8.29289C10.6834 7.90237 11.3166 7.90237 11.7071 8.29289C12.0976 8.68342 12.0976 9.31658 11.7071 9.70711L8.70711 12.7071C8.31658 13.0976 7.68342 13.0976 7.29289 12.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L8 10.5858L10.2929 8.29289Z",
    fill: "#071A24",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2929 15.2929C10.6834 14.9024 11.3166 14.9024 11.7071 15.2929C12.0976 15.6834 12.0976 16.3166 11.7071 16.7071L8.70711 19.7071C8.31658 20.0976 7.68342 20.0976 7.29289 19.7071L5.29289 17.7071C4.90237 17.3166 4.90237 16.6834 5.29289 16.2929C5.68342 15.9024 6.31658 15.9024 6.70711 16.2929L8 17.5858L10.2929 15.2929Z",
    fill: "#071A24",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7071 22.2929C11.3166 21.9024 10.6834 21.9024 10.2929 22.2929L8 24.5858L6.70711 23.2929C6.31658 22.9024 5.68342 22.9024 5.29289 23.2929C4.90237 23.6834 4.90237 24.3166 5.29289 24.7071L7.29289 26.7071C7.68342 27.0976 8.31658 27.0976 8.70711 26.7071L11.7071 23.7071C12.0976 23.3166 12.0976 22.6834 11.7071 22.2929Z",
    fill: "#071A24",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11C14 10.4477 14.4477 10 15 10H22C22.5523 10 23 10.4477 23 11C23 11.5523 22.5523 12 22 12H15C14.4477 12 14 11.5523 14 11Z",
    fill: "#071A24",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17C14.4477 17 14 17.4477 14 18C14 18.5523 14.4477 19 15 19H22C22.5523 19 23 18.5523 23 18C23 17.4477 22.5523 17 22 17H15Z",
    fill: "#071A24",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25C14 24.4477 14.4477 24 15 24H22C22.5523 24 23 24.4477 23 25C23 25.5523 22.5523 26 22 26H15C14.4477 26 14 25.5523 14 25Z",
    fill: "#071A24",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 2.68629 2.68629 0 6 0H22C25.3137 0 28 2.68629 28 6V28C28 31.3137 25.3137 34 22 34H6C2.68629 34 0 31.3137 0 28V6ZM6 2H22C24.2091 2 26 3.79086 26 6V28C26 30.2091 24.2091 32 22 32H6C3.79086 32 2 30.2091 2 28V6C2 3.79086 3.79086 2 6 2Z",
    fill: "#071A24",
    fillOpacity: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPoliciesWidgetEmptyStateIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/policies-widget-empty-state-icon.c88d9a1c710e02e6d441dc3f7b78dbd3.svg";